import $ from 'jquery';
import './inc/bootstrap.min';
import headerslider from "./theme/header-slider";
import cf7 from './theme/cf7';
import 'jquery-parallax.js';
import Parallax from './theme/parallax';

$(document).ready(function () {
  Parallax.init();

  headerslider();
  cf7();

  // Tab-Handling
  $('#remote-support-modal .nav-tabs a').click(function (e) {
    e.preventDefault();
    $('#remote-support-modal .nav-tabs li').removeClass('active');
    $(this).addClass('active');

    $('#remote-support-modal .tab-pane').removeClass('active');
    $($(this).attr('href')).addClass('active');
  });

  $('#location .nav-tabs a').click(function (e) {
    e.preventDefault();
    const getLink = $(this).attr('href');

    $('#location .nav-tabs li').removeClass('active');
    $(this).addClass('active');

    $('.tab-content .tab-pane').removeClass('active');
    $(getLink).addClass('active');
  });
  $('#location .tab-content .tab-pane:first()').addClass('active');

  // Windows ist standardmäßig aktiviert
  //if (navigator.appVersion.indexOf("Win")!=-1) ....;

  if (navigator.appVersion.indexOf("Mac")!=-1) {
    $('#remote-support-modal .nav-tabs a[href="#tab-macos"]').addClass('active');
  } else if (navigator.appVersion.indexOf("Linux")!=-1) {
    $('#remote-support-modal .nav-tabs a[href="#tab-linux"]').addClass('show');
  }

  // Smooth-Scroll und Fragment in der URL beibehalten
  $('a[href*="#"]').on('click', function(e){
    var anchorDestination = this.href;

    if (anchorDestination.includes('#cmpscreen')) {
      if (typeof __cmp === "function") {
        __cmp('showScreenAdvanced')
      }

      return;
    }

    if (this.href.search('#') > -1 && $(this.href.substring(this.href.search('#'))).length > 0){
      e.preventDefault();
      var anchorDestination = this.href.substring(this.href.search('#'));
      var $aElem = $(anchorDestination);

      $('html, body').animate({
        scrollTop: $aElem.offset().top
      }, 1000, function(){
        window.location = anchorDestination;
      });
    }
  });

  // Scroll-Logo
  $(document).scroll(function() {
    if($(document).scrollTop() > 100) {
      $('.navbar-brand .wrap').addClass('minified');
    } else {
      $('.navbar-brand .wrap').removeClass('minified');
    }
  });
});